import { motion } from "framer-motion";
import bg from "../../../app/assets/images/storyMagic/heroBg.png"
import BirdsIcon from "../../../app/assets/images/storyMagic/bird1.svg"

// Animation variants
const fadeInUp = {
  hidden: { opacity: 0, y: 60 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const fadeInLeft = {
  hidden: { opacity: 0, x: -50 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const fadeInRight = {
  hidden: { opacity: 0, x: 50 },
  visible: {
    opacity: 1,
    x: 0,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const scaleIn = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.1
    }
  }
};

const Herosection = () => {
  return (
    <div className="min-h-screen flex items-center w-full relative">
      <div className=" text-white w-full py-24 pb-10 lg:py-12">
        <motion.h1
          className="text-5xl lg:text-[80px] uppercase font-bold max-w-[1600px] px-5 mx-auto pb-5"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.3 }}
          variants={fadeInUp}
        >
          Story Magic
        </motion.h1>
        <motion.div
          className="flex flex-col lg:flex-row gap-5"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: false, amount: 0.3 }}
          variants={staggerContainer}
        >
          <motion.div
            className="py-10 bg-[#7F51D5] grow"
            variants={fadeInLeft}
          >
            <div className="max-w-[1600px] px-10 mx-auto ">
              <motion.p
                className="text-2xl lg:text-5xl pb-4 sm:pb-8 max-w-[500px] leading-[1.2]"
                variants={fadeInUp}
              >
                Create Magical Stories with Comfy UI
              </motion.p>
              <motion.ul
                className="list-inside list-disc text-xl lg:text-3xl *:font-bold space-y-3 lg:space-y-7"
                variants={staggerContainer}
              >
                <motion.li variants={fadeInUp}>8+ Art Styles</motion.li>
                <motion.li variants={fadeInUp}>Quick Generation</motion.li>
                <motion.li variants={fadeInUp}>Personalized Characters</motion.li>
              </motion.ul>
            </div>
          </motion.div>
          <motion.div
            className="lg:absolute top-0 bottom-0 my-auto right-11 h-fit lg:w-[53%]"
            variants={fadeInRight}
          >
            <motion.div
              className="relative lg:mt-[80px]"
              variants={scaleIn}
            >
              <img src={bg} alt="" />
              <motion.img
                src={BirdsIcon}
                className="absolute w-[20%] bottom-[32%]"
                alt=""
                initial={{ opacity: 0, y: 20, x: -20 }}
                whileInView={{
                  opacity: 1,
                  y: 0,
                  x: 0,
                }}
                viewport={{ once: false }}
                animate={{
                  y: [0, -15, 0],
                  rotate: [0, 5, -5, 0],
                }}
                transition={{
                  opacity: { delay: 0.6, duration: 0.8 },
                  x: { delay: 0.6, duration: 0.8 },
                  y: {
                    delay: 1.4,
                    duration: 3,
                    repeat: Infinity,
                    ease: "easeInOut",
                  },
                  rotate: {
                    delay: 1.4,
                    duration: 3,
                    repeat: Infinity,
                    ease: "easeInOut",
                  },
                }}
              />
            </motion.div>
          </motion.div>
        </motion.div>
      </div>
    </div>
  );
};

export default Herosection;
